<template>
  <div>
    <base-header class="pb-6" type="">
      <div class="row align-items-center py-4">
        <breadcrumbs :header="$t('Applications')"></breadcrumbs>
      </div>
    </base-header>
    <v-wait :for="waitFor">
      <template slot="waiting">
        <div class="container loader">
          <div class="row justify-content-md-center">
            <div class="col-md-auto">
              <spinner></spinner>
            </div>
          </div>
        </div>
      </template>
      <div class="container-fluid mt--6">
        <div class="row">
          <div class="col-md-4">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <h5 class="card-title text-uppercase text-muted mb-0">Поддержка через Telegram</h5>
                  </div>
                  <div class="col-auto">
                    <div class="icon icon-shape bg-gradient-teal text-white rounded-circle shadow">
                      <i class="fab fa-telegram"></i>
                    </div>
                  </div>
                </div>
                <p class="mt-3 mb-0 text-sm">
                  <a class="disabled" disabled>
                    <span class="text-nowrap">Настроить</span>
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-wait>

  </div>
</template>

<script>
  import Breadcrumbs from "../../Layout/Breadcrumbs";

  import Spinner from "vue-spinner-component/src/Spinner";

  export default {
    name: "CourseApps",
    components: {
      Breadcrumbs,
      Spinner
    },
    data() {
      return {
        waitFor: 'apps list fetching'
      }
    },
    created() {
      this.fetchData();
    },
    watch: {
      '$route': 'fetchData'
    },
    methods: {
      async fetchData() {
        this.$wait.start(this.waitFor);
        await setTimeout(() => {
        }, 1000);
        this.$wait.end(this.waitFor);
      },
    }
  }
</script>

<style scoped>

</style>
